import React from 'react';

const CeoVision = () => {
  return (
    <div className="container py-5">
      <h2 className="text-center text-primary mb-4">CEO's Vision</h2>

      <div className="row align-items-center">
        {/* Text Column */}
        <div className="col-md-7">
          <p style={{ textAlign: 'justify' }}>
            The world around us has changed more in the past two decades than perhaps in the past century.
            Things are moving so fast that predicting how businesses will operate and influence our lives is becoming increasingly difficult. 
            And the development that we see all around us has also brought fresh challenges.
            <br /><br />
            What has not changed, however, is the human mind’s undying curiosity to cross one frontier of knowledge after another.
            <br /><br />
            In the industrialized society that we live in today, information technology plays a role that’s broader and deeper than anything before. 
            It impacts the way people live, work, play, grow and interact.
            <br /><br />
            Inovaantage has been creating solutions that directly or indirectly serve the resources and utilities we all use on a daily basis. 
            Within that space, Inovaantage has been specializing in a wide range of solutions for power, telecom, and transportation and logistics.
            <br /><br />
            The variety of solutions that we create helps us serve practically every domain and every division of businesses in these industries. 
            At the same time, we’re inspired to do more.
            <br /><br />
            We feel both honored and elated to have been part of multiple mission-critical projects. 
            Our success lies in the fact that whatever we do, we do very well. 
            And we reaffirm our commitment to providing lasting solutions that make this planet a great place for all.
          </p>
        </div>

        {/* Image Column */}
        <div className="col-md-5 text-center">
          <img
            src="dr-sukanta.png"
            alt="CEO - Dr. Sukanta"
            className="img-fluid rounded shadow"
            style={{ maxHeight: '420px', objectFit: 'contain' }}
          />
          <h5 className="mt-3">Dr. Sukanta</h5>
          <p className="text-muted">CEO, Inovaantage</p>
        </div>
      </div>
    </div>
  );
};

export default CeoVision;
